import React from 'react';
import SendSuccess from '../../components/SendSuccess/SendSuccess';

const SuccessSend = () => {
  return (
    <div>
      <div className='App'>
        <SendSuccess />
      </div>
    </div>
  );
};

export default SuccessSend;
